module.exports = __webpack_public_path__ + "static/img/3.b03ddea.gif";


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/img/gif/3.gif
// module id = 810
// module chunks = 1